import { useReducer } from "react";
import { CustomizationState, DispatchCustomizationAction, reducer } from "../states/customization";

const useCustomizationReducer = (
  initialState: CustomizationState
): [CustomizationState, DispatchCustomizationAction] => {
  return useReducer(reducer, initialState);
};

export default useCustomizationReducer;
